export const mainImages = {
  front: 'about_me/front28.jpg',
  aboutMe: 'about_me/about4.jpg',
  contactBg: './pictures/4_letswork_picture.jpg',
  contact: 'about_me/contact5.jpg'
};
